import { render, staticRenderFns } from "./ActivityTraffic.vue?vue&type=template&id=3fb81ac7&scoped=true&"
import script from "./ActivityTraffic.vue?vue&type=script&lang=js&"
export * from "./ActivityTraffic.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTraffic.vue?vue&type=style&index=0&id=3fb81ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb81ac7",
  null
  
)

export default component.exports